// extracted by mini-css-extract-plugin
module.exports = {"radio":"dd31006766--radio--xCQqe","indicator":"dd31006766--indicator--I7rqt","label":"dd31006766--label--sOKWo"};